export default __webpack_public_path__ + "static/media/Offer.ce38c8ea.svg";